import { applyMiddleware, createStore, compose, combineReducers } from 'redux'
import thunk from "redux-thunk"
import { alertReducer } from './reducers/adminReducers';
import { sideMenuReducer } from './reducers/adminSideMenuReducer';
import { authReducer } from './reducers/authReducers';
import { saveCaptionReducer } from './reducers/langCaptReducers';
import { memActReducer } from './reducers/memActReducers';
import { eventDetailsReducer, languageTextDetails, loadingStatusReducer, streamAttendanceReportReducer } from './reducers/s2txtReducers';

const initialState = {
    user: {
        lvcconnectEventUserId: localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')).lvcconnectEventUserId : ''
    },
    langTxtDetails: {
        language: localStorage.getItem('langDetails')? JSON.parse(localStorage.getItem('langDetails')).language: '',
        live: localStorage.getItem('langDetails')? JSON.parse(localStorage.getItem('langDetails')).live: '',
        langCode: localStorage.getItem('langDetails')? JSON.parse(localStorage.getItem('langDetails')).langCode: '',
    }
}

const reducer = combineReducers({
    sideMenu: sideMenuReducer,
    loadingStatus: loadingStatusReducer,
    user: authReducer,
    langTxtDetails: languageTextDetails,
    savedCaption: saveCaptionReducer,
    eventDetails: eventDetailsReducer,
    alert: alertReducer,
    memAct: memActReducer,
    attendanceReport: streamAttendanceReportReducer
})

// Hides redux store in dev tools use for production
// const composeEnhancer = compose;

// Shows redux store in dev tools use for development
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    reducer,
    initialState, 
    composeEnhancer(applyMiddleware(thunk))
    )

export default store;